// @ts-nocheck
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import React, { FC } from "react";

export interface BreadcrumbStyles {}

export const breadcrumbStyles: BreadcrumbStyles = {};

const styles = breadcrumbStyles;

const Breadcrumbs: FC<WidgetProps> = () => <PageBreadcrumbs />;

const definition: WidgetDefinition = {
    group: "Common",
    displayName: "Breadcrumbs",
    icon: "ellipsis-stroke",
};

const widgetModule: WidgetModule = {
    component: Breadcrumbs,
    definition,
};

export default widgetModule;
